import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function ServiceEnquiry({ service }) {
  return <Link to={`/contact?service=${encodeURIComponent(service)}`}
    aria-label={`Enquire about ${service}`}
    className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:text-emerald-900">
    Enquire about this service <ArrowRight size={16} aria-hidden="true" />
  </Link>;
}
